module.exports = __webpack_public_path__ + "static/media/fire-smoke.2a3bb41e.svg";